import React from 'react';

import { SidebarContent, SidebarMenu } from 'components/ui/sidebar';

export const TemplateStudioSecondarySidebar: React.FC<{
  SidebarBlockComponent: React.FC;
}> = ({ SidebarBlockComponent }) => {
  return (
    <SidebarContent className="tb-secondary-sidebar-content w-[195px] max-w-[195px] h-full pr-2">
      <SidebarMenu className="tb-secondary-sidebar-menu gap-6">
        <SidebarBlockComponent />
      </SidebarMenu>
    </SidebarContent>
  );
};
